import type { SVGProps } from "react";
export function Twitter(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      data-slot="icon"
      {...props}
    >
      <clipPath id="a">
        <path d="m2 2h12v12h-12z" />
      </clipPath>
      <g
        clipPath="url(#a)"
        clipRule="evenodd"
        fill="currentColor"
        fillRule="evenodd"
      >
        <path d="m1.908 2.1519c.0846-.16967.25788-.2769.44747-.2769h2.8115c.15698 0 .30485.07373.39932.19909l8.47751 11.25001c.1141.1514.1327.3543.0481.524s-.2578.2769-.4474.2769h-2.8115c-.157 0-.3049-.0737-.3993-.1991l-8.47755-11.24999c-.11409-.15141-.13274-.35434-.04815-.52401zm1.45032.7231 7.72398 10.25h1.5593l-7.72392-10.25z" />
        <path d="m13.586 2.00932c.2019.18833.213.50472.0247.70668l-4.46855 4.792c-.18832.20196-.50471.21301-.70667.02468-.20196-.18832-.21302-.50471-.02469-.70667l4.46851-4.792c.1883-.20196.5047-.21302.7067-.02469z" />
        <path d="m7.56094 8.47103c.20196.18832.21302.50471.0247.70668l-4.465 4.78849c-.18832.202-.50471.213-.70667.0247-.20197-.1883-.21303-.5047-.02471-.7067l4.465-4.78846c.18832-.20197.50471-.21303.70668-.02471z" />
      </g>
    </svg>
  );
}
